module.exports = __webpack_public_path__ + "static/apple-icon-57x57-0748e72a4d52d9dab863c3d82f7a0d97.png";